<template>
  <form method="POST" class="form">
    <div class="form__field">
      <BaseField type="text" label="Имя" placeholder="Денис Абрамов" required v-model="name" />
    </div>
    <div class="form__field">
      <BaseField type="email" label="E-mail" placeholder="abramov.denis@gmail.com" required v-model="email" />
    </div>
    <div class="form__field">
      <BaseField label="Сообщение" placeholder="Спасибо! Было интересно!" required v-model="message" />
    </div>
    <div class="form__field">
      <BaseButton class="form__submit" type="submit" :disabled="isSubmitDisabled" @click="submit">
        Отправить
        <BaseIcon name="arrow" class="button__icon button__icon_after" />
      </BaseButton>
    </div>
  </form>
</template>

<script>
import BaseField from '@/components/BaseField.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'TheFeedbackForm',
  components: {
    BaseField,
    BaseButton,
    BaseIcon,
  },
  // props: {
  //   isHintsVisible: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  data() {
    return {
      name: '',
      email: '',
      message: '',
      // tel: '',
    };
  },
  // staticData: () => ({
  //   menu: slides.filter((slide) => slide.addToMenu),
  // }),
  computed: {
    isSubmitDisabled() {
      return !this.name || !this.email || !this.message;
    },
  },
  methods: {
    submit() {
      alert('Отправлено!');
    },
    // checkClick(e) {
    //   if (e.target.closest('.header__nav')) return;
    //   this.hideMenu();
    // },
    // showMenu() {
    //   this.isMenuOpen = !this.isMenuOpen;
    // },
    // hideMenu() {
    //   this.isMenuOpen = false;
    // },
  },
};
</script>
